import React from 'react';
import { Page } from '../Page';
const tocSections = [{
  part: 'Part One: Understanding Your Medication',
  items: [{
    title: 'What Is GLP-1 Medication?',
    page: 2
  }, {
    title: 'GLP-1 And The Gut',
    page: 3
  }, {
    title: 'GLP-1 And The Brain',
    page: 4
  }, {
    title: 'Managing Your Dose',
    page: 5
  }]
}, {
  part: 'Part Two: The Fundamentals',
  items: [{
    title: 'The Fundamentals',
    page: 6
  }, {
    title: 'Calories, Carbohydrates, and Fat',
    page: 7
  }, {
    title: 'Numbers Are a Starting Point',
    page: 8
  }]
}, {
  part: 'Part Three: The Essentials',
  items: [{
    title: 'Protein',
    page: 9
  }, {
    title: 'Choosing Lean Proteins',
    page: 10
  }, {
    title: 'Vitamins & Minerals',
    page: 11
  }, {
    title: 'Fiber',
    page: 12
  }, {
    title: 'Hydration',
    page: 13
  }, {
    title: 'When and How Often to Eat',
    page: 14
  }, {
    title: 'How to Plate a Meal',
    page: 15
  }, {
    title: 'The Fist Method',
    page: 16
  }, {
    title: 'Weight Lifting',
    page: 17
  }, {
    title: 'Cardio',
    page: 18
  }, {
    title: 'Sleep',
    page: 19
  }, {
    title: 'When Calories Start to Matter',
    page: 20
  }]
}];
const tocSections2 = [{
  part: 'Part Four: Supplements',
  items: [{
    title: 'Why Supplement Quality Matters',
    page: 21
  }, {
    title: 'Whey Protein',
    page: 22
  }, {
    title: 'Multivitamin',
    page: 23
  }, {
    title: 'Vitamin D',
    page: 24
  }, {
    title: 'CoQ10',
    page: 25
  }, {
    title: 'Omega-3',
    page: 26
  }, {
    title: 'Electrolytes',
    page: 27
  }, {
    title: 'Creatine',
    page: 28
  }, {
    title: 'Ashwagandha (Muscle)',
    page: 29
  }, {
    title: 'Sleep Support',
    page: 30
  }, {
    title: 'Magnesium',
    page: 31
  }, {
    title: 'Ashwagandha',
    page: 32
  }, {
    title: 'Glutathione',
    page: 33
  }]
}, {
  part: 'Part Five: Side Effects & Challenges',
  items: [{
    title: 'Acute Side Effects',
    page: 34
  }, {
    title: 'Chronic Side Effects',
    page: 35
  }, {
    title: 'Alcohol',
    page: 36
  }, {
    title: 'Plateaus',
    page: 37
  }]
}, {
  part: 'Part Six: Looking Ahead',
  items: [{
    title: 'Transitioning Off Medication',
    page: 38
  }]
}];
export function PageTOC() {
  return <Page hideFooter variant="light" data-id="element-1670" data-mp="1qk4v9p481tnz">
      <div className="flex flex-col h-full pt-12" data-id="element-1671" data-mp="1qj3d70osg6wr">
        <div className="mb-10" data-id="element-1672" data-mp="1vjrag43m1jzf">
          <h1 className="text-5xl font-serif text-[#1F1F1F] leading-tight" data-id="element-1673" data-mp="1vkiuqirrbvae">
            Table of
            <br data-id="element-1674" data-mp="1zl2t1po2h4y4" />
            Contents
          </h1>
          <div className="w-16 h-0.5 bg-tealslate mt-5" data-id="element-1675" data-mp="12vlm77dclcuu" />
        </div>

        <div className="grid grid-cols-2 gap-x-12 gap-y-8 flex-1" data-id="element-1676" data-mp="12tios29v8hg3">
          {/* Left column */}
          <div className="space-y-6" data-id="element-1677" data-mp="17s2dgafug7c5">
            {tocSections.map((section, sIdx) => <div key={sIdx} data-id="element-1678" data-mp="1btxcf8aay8mr" data-mpi={sIdx}>
                <div className="text-[10px] font-bold text-tealslate uppercase tracking-[0.15em] mb-2" data-id="element-1679" data-mp="1gmi689t7klqa">
                  {section.part}
                </div>
                <div className="space-y-0" data-id="element-1680" data-mp="k4lwu51xy111">
                  {section.items.map((item, iIdx) => <div key={iIdx} className="flex items-baseline gap-2 py-1 border-b border-[#D8D8D0] last:border-b-0" data-id="element-1681" data-mp="o4mhi7fmv8gj" data-mpi={iIdx}>
                      <span className="text-[#3B3B3B] text-xs" data-id="element-1682" data-mp="4aprs669giu">
                        {item.title}
                      </span>
                      <span className="flex-1 border-b border-dotted border-[#D8D8D0] mb-0.5" data-id="element-1683" data-mp="etgn1alg8wo3" />
                      <span className="text-tealslate font-bold text-xs tabular-nums" data-id="element-1684" data-mp="9z2pb1jbedg9">
                        {item.page}
                      </span>
                    </div>)}
                </div>
              </div>)}
          </div>

          {/* Right column */}
          <div className="space-y-6" data-id="element-1685" data-mp="xo5gazzu9inf">
            {tocSections2.map((section, sIdx) => <div key={sIdx} data-id="element-1686" data-mp="spc5jfbxs5qy" data-mpi={sIdx}>
                <div className="text-[10px] font-bold text-tealslate uppercase tracking-[0.15em] mb-2" data-id="element-1687" data-mp="2zhcug63ptu7q">
                  {section.part}
                </div>
                <div className="space-y-0" data-id="element-1688" data-mp="2ukutziff4i17">
                  {section.items.map((item, iIdx) => <div key={iIdx} className="flex items-baseline gap-2 py-1 border-b border-[#D8D8D0] last:border-b-0" data-id="element-1689" data-mp="1a2u17eivr15q" data-mpi={iIdx}>
                      <span className="text-[#3B3B3B] text-xs" data-id="element-1690" data-mp="10ao09fanh9ee">
                        {item.title}
                      </span>
                      <span className="flex-1 border-b border-dotted border-[#D8D8D0] mb-0.5" data-id="element-1691" data-mp="ra9e6dpv3q9u" />
                      <span className="text-tealslate font-bold text-xs tabular-nums" data-id="element-1692" data-mp="vbuwwfp2uyry">
                        {item.page}
                      </span>
                    </div>)}
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </Page>;
}